import { useEffect, useRef } from 'react';

export type ShortcutMap = Readonly<Record<string, () => void>>;

const TYPING_TAGS = new Set(['INPUT', 'TEXTAREA', 'SELECT']);

const isTyping = (target: EventTarget | null): boolean =>
  target instanceof HTMLElement && (TYPING_TAGS.has(target.tagName) || target.isContentEditable);

const isDialogOpen = (): boolean => document.querySelector('dialog[open]') !== null;

const isPlainKey = (event: KeyboardEvent): boolean => !event.ctrlKey && !event.metaKey && !event.altKey;

export const useShortcuts = (shortcuts: ShortcutMap): void => {
  const current = useRef(shortcuts);

  useEffect(() => {
    current.current = shortcuts;
  });

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.defaultPrevented || !isPlainKey(event) || isTyping(event.target) || isDialogOpen()) return;
      const run = current.current[event.key];
      if (run === undefined) return;
      event.preventDefault();
      run();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);
};
